// These constants exist in @kaggle/core to share between @kaggle/material and
// styled-components without introducing cyclical dependencies.
// TODO(b/251564517): Prefer accessing from styled-components theme.
export var GREY_900 = "#202124";
export var GREY_850 = "#2E2F32";
export var GREY_800 = "#3C4043";
export var GREY_700 = "#5F6368";
export var GREY_600 = "#80868B";
export var GREY_500 = "#9AA0A6";
export var GREY_400 = "#BDC1C6";
export var GREY_300 = "#DADCE0";
export var GREY_200 = "#E8EAED";
export var GREY_100 = "#F1F3F4";
export var GREY_50 = "#F8F9FA";
export var BLUE_600 = "#0096EE";
export var GREEN_600 = "#1E8E3E";
export var GREEN_400 = "#5BB974";
export var RED_600 = "#D93025";
export var RED_400 = "#EE675C";
export var RED_50 = "#FCE8E6";
export var YELLOW_900 = "#E37400";
export var YELLOW_400 = "#FCC934";
export var KAGGLE_BLUE = "#20BEFF";
export var KAGGLE_GREEN = "#1CCD76";
export var KAGGLE_PURPLE = "#651FFF";
export var KAGGLE_ORANGE = "#FF5C19";
export var KAGGLE_YELLOW = "#E5CF4A";
export var KAGGLE_BLACK = GREY_900;
export var KAGGLE_WHITE = "#FFFFFF";
export var KAGGLE_FOCUS = KAGGLE_BLUE;
export var ILLUSTRATION_BLUE = KAGGLE_BLUE;
export var ILLUSTRATION_GREEN = "#1FA641";
export var ILLUSTRATION_YELLOW = "#FAE041";
export var ILLUSTRATION_BLACK = KAGGLE_BLACK;
